import React, { useEffect, useRef, useState } from "react";
import { Input, DatePicker, Button } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { toast } from "react-toastify";
import LoadingSpinner from "../CustomWidgets/Laoding";
import { useSelector } from "react-redux";
import AlphaNumericKeyboardModal from "../Modal/AlphaNumericKeyboardModal";
import { detectWebDeviceType } from "../../utils";
import i18next from "i18next";

const { TextArea } = Input;

export function CustomerForm({ onSubmit, orderDetails }) {
  const [transactionDate, setTransactionDate] = useState(dayjs());
  const [paymentAmount, setPaymentAmount] = useState("");
  const [remark, setRemark] = useState("");
  const [remainingAmount, setRemainingAmount] = useState(0);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state?.login?.user?.result);
  const deviceType = detectWebDeviceType();

  const { t } = useTranslation();
  const [showKeyboard, setShowKeyboard] = useState(false);
  const [keyboardMode, setKeyboardMode] = useState("numeric"); // or "alphanumeric"
  const [focusedField, setFocusedField] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const printRef = useRef(); // ✅ PRINT REF

  const handleCustomKeyPress = (key) => {
    if (key === "DEL") {
      if (focusedField === "paymentAmount") {
        // setPaymentAmount((prev) => prev.slice(0, -1));
        setPaymentAmount((prev) =>
          typeof prev === "string" ? prev.slice(0, -1) : ""
        );
      } else if (focusedField === "remark") {
        setRemark((prev) => prev.slice(0, -1));
      }
    } else if (key === "SPACE") {
      if (focusedField === "remark") {
        setRemark((prev) => prev + " ");
      }
    } else {
      if (focusedField === "paymentAmount") {
        const updated = paymentAmount + key;
        if (/^[0-9]*\.?[0-9]{0,2}$/.test(updated) && updated.length <= 10) {
          setPaymentAmount(updated);
          const remaining = orderDetails.credit_amount - updated;
          setRemainingAmount(remaining >= 0 ? remaining : 0);
        }
      } else if (focusedField === "remark") {
        if (remark.length < 50) {
          setRemark((prev) => prev + key);
        }
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; // prevent double submit
    setIsSubmitting(true);

    // console.log("ORDEERRRR--->", orderDetails);
    if (!remark) {
      toast.error(t("Please enter remark"));
    }

    const payload = {
      pos_credit_id: orderDetails?.pos_credit_id,
      paid_amount: parseFloat(paymentAmount),
      payment_date: transactionDate.format("YYYY-MM-DD"),
      remark: remark,
      lang: i18next.language === "ar" ? "ar_001" : "en_US"
    };

    try {
      const response = await axiosInstance.post(
        URLS.POS_CREDIT_PAYMENT,
        payload
      );

      const isPaymentSuccess =
        response.data?.result[0]?.status_code === 200 &&
        response.data?.result[0]?.status === "POS Credit Payment Done";

      if (isPaymentSuccess) {
        toast.success(t("Payment Submitted Successfully"));

        try {
          const cashInPayload = {
            lang: i18next.language === "ar" ? "ar_001" : "en_US",
            session_id: userData?.session_id,
            type: "cash_in",
            amount: parseFloat(paymentAmount),
            reason: `CREDIT IN - ${orderDetails?.customer_name} (${orderDetails?.mobile_no})`,
            is_refund_with_new: false,
            is_credit_order: false
          };

          const cashInResponse = await axiosInstance.post(
            URLS.CASH_IN_OUT,
            cashInPayload
          );

          if (cashInResponse?.data?.status !== "Success") {
            console.error("Cash in failed:", cashInResponse?.data);
          }
        } catch (cashInErr) {
          console.error("Error in CASH_IN_OUT API:", cashInErr);
        }

        onSubmit(); // callback after everything is successful
      } else {
        console.error("Error submitting payment:", response.data);
      }
    } catch (error) {
      console.error("Error submitting payment:", error);
    } finally {
      setIsSubmitting(false); // re-enable the button
    }
  };
  useEffect(() => {
    if (deviceType === "tablet") {
      setShowKeyboard(true);
      setFocusedField("paymentAmount"); // or "remark"
      setKeyboardMode("numeric"); // or "alphanumeric"
    }
  }, [deviceType]);

  useEffect(() => {
    if (orderDetails) {
      fetchPaymentHistory();
      setPaymentAmount(orderDetails?.credit_amount);
      setRemainingAmount(0);
    }
  }, [orderDetails]);

  const fetchPaymentHistory = async () => {
    if (orderDetails?.pos_credit_id) {
      setLoading(true);
      try {
        const response = await axiosInstance.post(
          URLS.POS_CREDIT_PAYMENT_HISTORY,
          {
            pos_credit_id: orderDetails.pos_credit_id,
          }
        );

        if (response.data?.result[0]?.status_code === 200) {
          setPaymentHistory(response.data?.result[0]?.credit_payment_id || []);
          setLoading(false);
        } else {
          console.error("Error fetching payment history:", response.data);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching payment history:", error);
        setLoading(false);
      }
    }
  };

  const formatDate = (date) => {
    return dayjs(date).format("DD-MM-YYYY");
  };

  const handlePaymentChange = (e) => {
    const amount = e.target.value;

    if (/^[0-9]*\.?[0-9]{0,2}$/.test(amount) && amount.length <= 10) {
      setPaymentAmount(amount);

      const remaining = orderDetails.credit_amount - amount;
      setRemainingAmount(remaining >= 0 ? remaining : 0);
    }
  };

  const disableFutureDates = (current) => {
    return current && current.isAfter(dayjs());
  };

  const isPaymentValid =
    paymentAmount <= orderDetails?.credit_amount && paymentAmount > 0;

  const isCreditAmountZero = orderDetails?.credit_amount === 0;

 const handlePrint = () => {
  const content = printRef.current.innerHTML;

  const printWindow = window.open("", "", "width=800,height=600");

  printWindow.document.write(`
    <html>
      <head>
        <title>Customer Credit</title>
        <style>
          body {
            font-family: Arial;
            font-size: 12px;
            color: #000;
            display: flex;
            justify-content: center;
          }

          .container {
            width: 320px; /* 🔥 controls print width (like receipt) */
          }

          h2 {
            font-size: 16px;
            margin-bottom: 6px;
            text-align: center;
          }

          h3 {
            font-size: 13px;
            margin-top: 10px;
            margin-bottom: 5px;
          }

          p {
            margin: 2px 0;
            font-size: 12px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 6px;
          }

          th, td {
            border: 1px solid #ccc;
            padding: 4px;
            font-size: 11px;
            text-align: left;
          }

          th {
            background-color: #f0f0f0;
          }

          tr {
            line-height: 1.2;
          }

          /* better spacing for customer info */
          .customer-block {
            margin-bottom: 8px;
          }
        </style>
      </head>
      <body>
        <div class="container">
          ${content}
        </div>
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
};
 const thStyle = {
    border: "1px solid #ccc",
    padding: "8px",
    background: "#f5f5f5",
    textAlign: "left",
  };

  const tdStyle = {
    border: "1px solid #ccc",
    padding: "8px",
  };



  return (
    <>
      {loading && <LoadingSpinner />}
      <div
        className="grid grid-cols-1 md:grid-cols-2 gap-6 relative
      "
      >
        <div className="space-y-4  ">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-lg text-gray-600">{t("Name")}</label>
              <div className="flex gap-4">
                <Input
                  type="text"
                  value={orderDetails?.customer_name || ""}
                  readOnly
                  className="mt-1 block w-full rounded-md border font-semibold bg-gray-100 border-gray-300 px-3 py-2 text-lg"
                />
              </div>
            </div>
            <div>
              <label className="block text-lg text-gray-600">
                {t("Phone No.")}
              </label>
              <Input
                type="text"
                value={orderDetails?.mobile_no || ""}
                readOnly
                className="mt-1 block w-full rounded-md border font-semibold bg-gray-100 border-gray-300 px-3 py-2 text-lg"
              />
            </div>
          </div>

          <div>
            <label className="block text-lg text-gray-600">
              {t("Address")}
            </label>
            <Input
              type="text"
              value={orderDetails?.address || ""}
              readOnly
              className="mt-1 block w-full rounded-md border font-semibold bg-gray-100 border-gray-300 px-3 py-2 text-lg mb-10"
            />
          </div>

          <div className="">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-lg text-gray-600">
                  {t("Total Balance")}
                </label>
                <Input
                  type="text"
                  value={`EGP ${orderDetails?.credit_amount || 0}`}
                  readOnly
                  className="mt-1 block w-full font-semibold bg-gray-100 rounded-md border border-gray-300 px-3 py-2 text-lg"
                />
              </div>
              {/* <br></br> */}

              {!isCreditAmountZero && (
                <div>
                  <label className="block text-lg text-gray-600">
                    {t("Remaining Amount")}
                  </label>
                  <Input
                    type="text"
                    value={`EGP ${remainingAmount}`}
                    readOnly
                    className="mt-1 block w-full font-semibold bg-gray-100 rounded-md border border-gray-300 px-3 py-2 text-lg"
                  />
                </div>
              )}
            </div>
          </div>

          {!isCreditAmountZero && (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-lg mb-1 text-gray-600">
                    {t("Payment Amount")}
                  </label>
                  <Input
                    type="text"
                    value={paymentAmount}
                    onChange={handlePaymentChange}
                    placeholder="EGP"
                    readOnly={deviceType === "tablet"} // prevent default keyboard
                    onFocus={() => {
                      if (deviceType === "tablet") {
                        setKeyboardMode("numeric");
                        setFocusedField("paymentAmount");
                        setShowKeyboard(true);
                      }
                    }}
                    className={`mt-2 block font-semibold w-full rounded-md border px-3 py-2 text-lg ${!isPaymentValid ? "border-red-600" : "border-gray-800"
                      }`}
                  />
                </div>
                {deviceType === "pc" && (
                  <div>
                    <label className="block text-lg mb-2 text-gray-600">
                      {t("Transaction Date")}
                    </label>
                    <DatePicker
                      value={transactionDate}
                      onChange={(date) => setTransactionDate(date)}
                      format="DD-MM-YYYY"
                      disabledDate={disableFutureDates}
                      className="mt-1 block w-full rounded-md border font-semibold border-gray-800 px-3 py-2 text-xl"
                      size="large"
                      allowClear={false}
                    />
                  </div>
                )}
                {deviceType === "tablet" && (
                  <div>
                    <label className="block text-lg mb-2 text-gray-600">
                      {t("Transaction Date")}
                    </label>
                    <input
                      type="date"
                      value={transactionDate.format("YYYY-MM-DD")}
                      onChange={(e) => setTransactionDate(dayjs(e.target.value))}
                      max={dayjs().format("YYYY-MM-DD")} // disables future dates
                      className="mt-1 block outline-none focus:outline-none bg-transparent w-full rounded-md border font-semibold border-gray-800 px-3 py-2 text-lg"
                      style={{ height: "45px" }}
                    />
                  </div>
                )}

              </div>

              <div>
                <label className="block text-lg text-gray-600">
                  {t("Remark")}
                </label>
                <Input
                  type="text"
                  maxLength={50}
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  readOnly={deviceType === "tablet"} // block default keyboard
                  onFocus={() => {
                    if (deviceType === "tablet") {
                      setKeyboardMode("alphanumeric");
                      setFocusedField("remark");
                      setShowKeyboard(true);
                    }
                  }}
                  className={`mt-1 block w-full rounded-md border font-semibold  px-3 py-2 text-lg mb-10 ${!remark ? "border-red-600" : "border-gray-800"
                    }`}
                />
              </div>
              <button
                disabled={!isPaymentValid || isSubmitting || !remark}
                className={`justify-center items-center px-16 py-3.5 mt-20 text-xl text-center text-white font-semibold capitalize whitespace-nowrap bg-[#7EC242] rounded-lg max-md:px-5 max-md:mt-10 max-md:max-w-full ${!isPaymentValid || !remark ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                onClick={handleSubmit}
              >
                {t("Collect Payment")}
              </button>
            </form>
          )}
        </div>
        <div className="bg-gray-50 p-4 rounded-lg">
         <div className="flex justify-between items-center mb-4">
  <h3 className="text-xl font-semibold">{t("Payment History")}</h3>

  <button
    onClick={handlePrint}
    className="px-6 py-2 bg-[#1b4597] text-white rounded-lg "
  >
    {t("Print")}
  </button>
</div>
          <div className="space-y-2">
            {paymentHistory.length > 0 ? (
              <>
                <div className="grid grid-cols-3 font-medium text-gray-600 pb-2 sticky top-0 bg-gray-50">
                  <span>{t("Payment Date")}</span>
                  <span>{t("Paid")}</span>
                  <span>{t("Remark")}</span>
                </div>
                <div className="space-y-2 max-h-[500px] overflow-y-auto pe-2 scrollbar-thin">
                  {paymentHistory.map((payment, index) => (
                    <div
                      key={index}
                      className="grid grid-cols-3 text-gray-800 py-2 border-b border-gray-200 hover:bg-gray-100 transition-colors"
                    >
                      <span>{formatDate(payment?.payment_date)}</span>
                      <span>{`EGP ${payment?.paid_amount}`}</span>
                      <span>{payment?.remark}</span>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="text-gray-600 py-2 text-center">
                {t("No data found")}
              </div>
            )}
          </div>
        </div>
        {deviceType === "tablet" && showKeyboard && (
          <AlphaNumericKeyboardModal
            onClose={() => setShowKeyboard(false)}
            onKeyPress={handleCustomKeyPress}
            mode={keyboardMode}
            width="37%"
            maxWidth="37%"
            maxHeight="64%"
            right="3rem"
            top="50%"
          />
        )}

        
      </div>

       <div style={{ display: "none" }}>
        <div ref={printRef}>
          <h2>{t("Customer Details")}</h2>

          <p><strong>{t("Name")}:</strong> {orderDetails?.customer_name}</p>
          <p><strong>{t("Phone")}:</strong> {orderDetails?.mobile_no}</p>
          <p><strong>{t("Address")}:</strong> {orderDetails?.address}</p>

          <h3 style={{ marginTop: "20px" }}>{t("Payment History")}</h3>

          <table>
            <thead>
              <tr>
                <th style={thStyle}>{t("Date")}</th>
                <th style={thStyle}>{t("Paid")}</th>
                <th style={thStyle}>{t("Remark")}</th>
              </tr>
            </thead>
            <tbody>
              {paymentHistory.map((payment, index) => (
                <tr key={index}>
                  <td style={tdStyle}>
                    {formatDate(payment.payment_date)}
                  </td>
                  <td style={tdStyle}>
                    EGP {payment.paid_amount}
                  </td>
                  <td style={tdStyle}>
                    {payment.remark || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
